import { Link } from 'react-router-dom';

export default function WhySection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px]">
      <div className="lg:w-1/2 relative overflow-hidden min-h-[320px] lg:min-h-[560px]">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20editorial%20image%20with%20flowing%20silk%20and%20linen%20textiles%20in%20warm%20terracotta%20cream%20and%20dusty%20sage%20tones%20cascading%20elegantly%20over%20organic%20sculptural%20forms%20soft%20diffused%20natural%20backlight%20creating%20depth%20and%20atmosphere%20abstract%20luxurious%20composition%20no%20people%20no%20text%20no%20logos&width=1000&height=700&seq=why-section-v2-fresh-01&orientation=portrait"
          alt="Why PandabuySpreadsheet"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background-50/30"></div>
        <div className="absolute top-8 left-8">
          <span className="text-xs font-medium uppercase tracking-widest text-foreground-700 bg-background-50/80 backdrop-blur-sm px-3 py-1.5 rounded-full">
            Original Content
          </span>
        </div>
        <div className="absolute bottom-8 left-8">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
            Curated
            <br />
            Shopping
            <br />
            Intelligence
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center">
        <div className="px-8 md:px-12 lg:px-16 py-12 md:py-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            Why PandabuySpreadsheet
          </h2>
          <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
            Unlike random Reddit threads or abandoned spreadsheets with dead links, PandabuySpreadsheet is a living, breathing resource maintained by active community members who verify every listing. Our pandabuy spreadsheet covers fourteen curated categories — from sneakers and hoodies to perfumes and bags — ensuring you never miss a deal or waste time on unreliable sellers. Each entry includes pricing data, quality ratings, sizing guidance, and direct product links, all organized in an intuitive, easy-to-navigate format that saves hours of research time.
          </p>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
            The key difference is continuous updates. While other pandabuy spreadsheet resources go stale within weeks, ours receives fresh listings and dead-link removals on a daily basis, backed by real buyer feedback and community quality checks that keep the entire catalog accurate and trustworthy.
          </p>
          <Link
            to="/guide/pandabuy-sheet-guide"
            className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Read Full Guide
            <i className="ri-arrow-right-up-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}